module.exports = __webpack_public_path__ + "img/four_logo.67739319.png";